import client from "./client";

const PATHS = {
  productsList: "/products/v1.0/products",
  productById: (id) => `/products/v1.0/products/${id}`,
  filters: "/products/v1.0/filters",
  filterOptions: "/products/v1.0/filters/options",
  hero: "/products/v1/getHomeHero",
  productMedia: "/products/v1/getProductMedia",
  categoryFeaturedImages: "/products/v1/getCategoryFeaturedImage",
};

export async function getProducts({
  filters = {},
  category = "",
  page = 1,
  sort = "",
  signal,
} = {}) {
  const params = {
    filters: JSON.stringify(filters),
    page,
  };
  if (sort) {
    params.sort = sort;
  }
  if (category) {
    params["product_cat[]"] = category;
  }
  const { data } = await client.get(PATHS.productsList, { params, signal });
  return data;
}

export async function getProductById(id, { signal } = {}) {
  const { data } = await client.get(PATHS.productById(id), { signal });
  return data;
}

export async function getRelatedProducts(
  { material, excludeId },
  { signal } = {}
) {
  const params = {
    exclude: excludeId,
    sort: "product-cat-low",
    filters: JSON.stringify({ materials: [material] }),
  };
  const { data } = await client.get(PATHS.productsList, { params, signal });
  return data;
}

export async function getFilters(category, { signal } = {}) {
  const { data } = await client.get(PATHS.filters, {
    params: { product_cat: category },
    signal,
  });
  return data;
}

export async function getFilterOptions(category, { signal } = {}) {
  const { data } = await client.get(PATHS.filterOptions, {
    params: { product_cat: category },
    signal,
  });
  return data;
}

export async function getHero({ signal } = {}) {
  const { data } = await client.get(PATHS.hero, { signal });
  return data;
}

export async function getProductMedia(id, { signal } = {}) {
  const { data } = await client.get(PATHS.productMedia, {
    params: { id },
    signal,
  });
  return data;
}

export async function searchProducts(query, { signal } = {}) {
  return getProducts({ filters: { searching: query }, page: 1, signal });
}

export async function getCategoryFeaturedImages({ signal } = {}) {
  const { data } = await client.get(PATHS.categoryFeaturedImages, { signal });
  return data;
}
